import { Check, ChevronsUpDown } from 'lucide-react'

import { cn } from 'src/utils'

import { useSelectCurrencyInput } from 'src/features/SelectCurrencyInput/useSelectCurrencyInput'
import {
  Popover,
  PopoverTrigger,
  PopoverContent,
} from 'src/components/shadcn/popover'
import {
  Command,
  CommandGroup,
  CommandItem,
  CommandInput,
  CommandList,
  CommandEmpty,
} from 'src/components/shadcn/command'
import { Button } from 'src/components/shadcn/button'

export const SelectCurrencyInput = ({}): JSX.Element => {
  const { locale, setOpen, open, value, onSelectCurrency, listOfCurrencies } =
    useSelectCurrencyInput()

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          role="combobox"
          aria-expanded={open}
          className="w-full justify-between"
        >
          {value
            ? listOfCurrencies
                .find(currency => currency === value)
                ?.toUpperCase()
            : locale.selectCurrency}
          <ChevronsUpDown className="opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[var(--radix-popover-trigger-width)] p-0">
        <Command>
          <CommandInput placeholder={locale.selectCurrency} className="h-9" />
          <CommandList>
            <CommandEmpty>No topic found.</CommandEmpty>
            <CommandGroup>
              {listOfCurrencies.map(currency => (
                <CommandItem
                  key={currency}
                  value={currency}
                  onSelect={() => onSelectCurrency(currency)}
                >
                  {currency.toUpperCase()}
                  <Check
                    className={cn(
                      'ml-auto',
                      value === currency ? 'opacity-100' : 'opacity-0',
                    )}
                  />
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  )
}
